<script module lang="ts">
  import type {
    BlogCategory as BlogCategoryType,
    BlogPost as BlogPostType,
    Pagination
  } from '@agapi/mlc-core';

  export type BlogPostPageData =
    | {
        isCategory: true;
        isPost?: false;
        category: BlogCategoryType;
        posts: BlogPostType[];
        pagination: Pagination;
        locale: string;
        alternates: Record<string, string>;
      }
    | {
        isCategory?: false;
        isPost: true;
        post: BlogPostType;
        locale: string;
        alternates: Record<string, string>;
      };
</script>

<script lang="ts">
  import { BlogCategory, BlogPost } from '../../../components';
  import { AlternateLinks } from '@agapi/ui/alternate-links';

  const { data }: { data: BlogPostPageData } = $props();

  console.log('blog data', data);
</script>

{#if data.isCategory}
  <BlogCategory
    lang={data.locale}
    category={data.category}
    posts={data.posts}
    pagination={data.pagination}
  />
{:else if data.isPost}
  <BlogPost post={data.post} lang={data.locale} />
{/if}

<AlternateLinks links={data.alternates} />
